import React, { useContext, useState } from 'react'
import axios from 'axios'
import { UserContext } from '../../../../App'

export function useNewBook({ setLoad }) {

  const { user, setUser } = useContext(UserContext)
  const token = localStorage.getItem('token')

  const [address, setAddress] = useState(user?.address)
  const [error_address, setError_Address] = useState('');

  const [phone, setPhone] = useState((typeof user !== 'undefined' && 'phone' in user) ? user.phone.slice(2) : "");
  const [error_phone, setError_Phone] = useState('');


  const updateAddress = async () => {
    if (typeof address !== 'undefined' && ('line1' && 'postal_code' && 'city' in address)) {
      if (address !== user.address) {
        setLoad(true)
        let values = {
          'address': {
            'line1': address.line1,
            'postal_code': address.postal_code,
            'city': address.city,
          }
        }
        try {
          const response = await axios({
            method: 'post',
            url: '/api/setAddress',
            data: {
                values
            },
            headers: {
                Authorization: `Bearer ${token}`
            }
          });

          setUser(response.data);
          setLoad(false)

          return response.data;

        } catch (err) {
          console.log(err)
          return user;
        }
      } else {
        return user;
      }
    } else {
      setError_Address('Indtast din adresse')
    }
  }

  function updatePhone({goToNextStep}) {
    setError_Phone('')
    if (phone.length === 8) {
      setLoad(true)
      axios({
        method: 'post',
        url: '/api/newPhone',
        data: {
          phone: "45" + phone
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        const updatedUser = {
          ...user,
          'phone': response.data.phone
        };
        setUser(updatedUser)
        goToNextStep(updatedUser)
        setLoad(false)
      })
      .catch(error => {
        if (error.response.data.type === 1) {
          const updatedUser = {
            ...user,
            verified_phone: true
          };
          setUser(updatedUser)
          goToNextStep(updatedUser)
        } else {
          setError_Phone('Vent 10 minutter før du kan få en ny kode')
        }
        setLoad(false)
        console.log(error);
      });
    } else {
      setError_Phone('Indtast et gyldigt telefonnummer')
    }
  }

  return { updateAddress, address, setAddress, error_address, setError_Address, updatePhone, phone, setPhone, error_phone, setError_Phone }
}